import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Link } from 'react-router-dom'
import { Icon } from 'semantic-ui-react'
import DataTable from '../datatable'
import InterviewStatus, { statusList } from './status'

const columns = [
  {
    name: 'name',
    label: 'Nimi',
    sortable: true,
    link(item) {
      return `/project/${item.get('project_id')}/interview/${item.get('id')}`
    },
  },
  {
    name: 'project_id',
    label: 'Projekti',
    render(i) {
      return <Link to={`/project/${i.get('project_id')}`}>{i.getIn(['project', 'name'])}</Link>
    },
  },
  {
    name: 'status',
    label: 'Status',
    sortable: true,
    width: 400,
    render(i) {
      return <InterviewStatus interview={i} />
    },
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
    defaultSort: true,
  },
  {
    name: 'updated_at',
    label: 'Päivitetty',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
  },
]

const filterFields = [
  {
    name: 'status',
    type: 'buttons',
    label: 'Tila',
    multiple: true,
    options: Object.keys(statusList).map(k => ({
      value: k,
      label: statusList[k],
    })),
  },
]

export default function ProjectRoot() {
  return (
    <DataTable
      id="interviews"
      entity="interview"
      title="Haastattelut"
      filters
      filterFields={filterFields}
      sortDir="desc"
      columns={columns}
    />
  )
}
